
import React from 'react';
import { FacilityOrderTemplateNewFlowInsuranceProductModalTemplate } from 'themes/application/facility-order-new-flow-insurance/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateNewFlowInsuranceProductModalStore } from 'application/facility-order-new-flow-insurance/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateNewFlowInsuranceProductModalStore(rootStore, componentProps), 'facilityOrderTemplateNewFlowInsuranceProductModalStore')
@observer
class FacilityOrderTemplateNewFlowInsuranceProductModal extends React.Component {
    render() {
        return <FacilityOrderTemplateNewFlowInsuranceProductModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateNewFlowInsuranceProductModal;
